import { Box, Text, Button } from '@betty/moonlight';
import { memo, useCallback, useEffect, useState } from 'react';
import { Screen, useNavigation } from '@betty/navigation';
import { Trans, useTranslation } from '@betty/i18n';
import PeriodSelect from '../../components/ResponsibleGaming/components/PeriodSelect/PeriodSelect';
import { Linking } from 'react-native';
import TimeoutCard from '../../components/ResponsibleGaming/components/TimeoutCard';
import { useDispatch } from '@betty/toolkit/state';
import { openChat } from '@betty/chat/state';

function SelfExclusionScreen() {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { t } = useTranslation('responsibleGaming');

  useEffect(() => {
    navigation.setOptions({ title: t('selfExclusion') });
  }, [navigation, t]);

  const [period, setPeriod] = useState<string | null>(null);

  const onSubmitPress = useCallback(() => {
    navigation.navigate('SelfExclusionVerify', {
      value: period,
    });
  }, [navigation, period]);

  const handleMailPress = useCallback(() => {
    Linking.openURL(encodeURI('mailto:support@betty.ca'));
  }, []);

  const handleOpenChat = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  return (
    <Screen>
      <Box marginTop="space-400" gap="space-800">
        <Text
          variant="body-m-semi"
          locNS="responsibleGaming"
          locKey="selfExclusionTitle"
          color="darkSurfacePrimary"
        />

        <TimeoutCard />

        <Box gap="space-200">
          <Text variant="body-m-semi" color="darkSurfacePrimary">
            <Trans
              ns="responsibleGaming"
              i18nKey="selfExclusionWarning"
              components={{
                email: (
                  <Text
                    variant="body-m-semi"
                    color="darkSurfaceAccentSolid"
                    underline
                    onPress={handleMailPress}
                  />
                ),
                chat: (
                  <Text
                    variant="body-m-semi"
                    color="darkSurfaceAccentSolid"
                    underline
                    onPress={handleOpenChat}
                  />
                ),
              }}
            />
          </Text>

          <PeriodSelect type="SelfExclusion" setValue={setPeriod} />
        </Box>
        <Button
          variant="secondary"
          onPress={onSubmitPress}
          locNS="responsibleGaming"
          locKey="selfExclusionButton"
          disabled={!period}
        />
      </Box>
    </Screen>
  );
}

export default memo(SelfExclusionScreen);
